export const langEn = {
    ticketLgy: {
        AuditResult: 'Audit Result',
        ExcepQuestion: 'Abnormal Problems',
        ExcepAnswer: 'Exception Option',
        TicketsTotal: 'Tickets Total',
        Invalid: "Invalid",
        Effected: "effected",
        Unblock: "Unblock",
        Status: "Status",
        Normal: "Normal",
        invalid: "Invalid",
        Block: "block",
        Success: "Success",
        Failed: "Failed",
        TicketTag: "Ticket Tag",
        PartialCompletionTime: "Partial completion time",
        GoogleVerification: "Google Verification",
        Active: "Active",
        Di: "Disable",
        Outsourcingornot: "Employee type",
        LocalCollection: "Local Collection",
        Outsourcing: "Outsourcing",
        All: "All",
        PhoneVerify: "Phone Verify",
        plschoose: "pls choose",
        plsinputID: "pls input ID",
        TotalRepayment: "Total Amount",
        UserRepaymentIntoAccount: "user payment",
        UserRpaymentTime: "user payment time",
        Rollover: "Extension payment",
        RolloverTime: "Extension payment time",
        CouponCredited: "Coupon payment",
        CouponCreditTime: "Coupon payment time",
        DeductionCredited: "Discount payment",
        DeductionCreditedTime: "Discount payment time",
        OtherEntry: "Other payment",
        OtherEntryTime: "Other payment time",
        ButtonManagement: "Button management",
        ListManagement: "List management",
        Button: "Button",
        Authority: "Authority",
        Add: "Add",
        Edit: "Edit",
        Delete: "Delete",
        RouteList: "Route list",
        addaFirstLevelPage: "新增一级页面",
        Save: "保存",
        AddCallList: "New call list",
        ListOrderConfiguration: "List order configuration",
        ListOrder: "List order",
        ListList: "List list",
        AutoDial: "Auto-Dial",
        Stop: "Stop automatic dialing",
        DialID: "Call ID",
        NextCallTime: "Next call time",
        Approve: "approve",
        Fail: "fail",
        Invalidation: "invalidation",
        RejectAnApplication: "reject an application",
        BasicInformation: "basic information",
        OrderTag: "ticket label",
        ManualReview: "manual review",
        ContactInformationAudit: "contact information audit",
        CustomerInformationAudit: "customer information audit",
        PhoneReview: "Phone review",
        AuditCompleted: "audit completed",
        LaterProcessing: "later processing",
        Male: "male",
        Female: "female",
        Secrecy: "Mantener secreto",
        OutCall: "out Call",
        SaveCallLog: "Save call log",
        DialingMethod: "Dialing method",
        InSystem: "In the system",
        OutsideSystem: "Outside the system",
        QualityInspectionResults: "Quality inspection results",
        QualityInspectionNotes: "Quality inspection notes",
        TelemarketingDistribution: "Telemarketing distribution"
    },
    formLgy: {
        Supplier: "Supplier",
        ExtensionNumber: "extension number",
        Name: "name",
        RoleList: "role list",
        TicketCategory: "Ticket Category",
        QueryDimension: "Query Dimension",
        Date: "date",
        Coupon: "Coupon",
        ButtonSelection: "按钮选择",
        Routing: "路由选择",
        Aging: "Aging",
        QueueSorting: "Queue sorting",
        ListCallOrder: "List call order",
        TicketMaxWorkingNumberHistory: "Ticket max working number of history",
        EffectiveDate: "Effective date",
        TicketCrowdRoleGroup: "Ticket crowd (role group)",
        TicketCrowdRoleGroup2: "Role group:",
        TotalTickets: "工单总量:",
        LeftTicket:'分配后剩余单量:',
        orderTags: 'Tags',
    },
    tableLgy: {
        AverageCallVolume: "Average call volume",
        AverageConnectionAmount: "Average connection amount",
        EmployeeRole: "Employee role",
        Leader: "Leader",
        Groupleader: "Group leader",
        ConnectedRate: "Connected Rate",
        CallMedian: "Call Median",
        RegistrationTime: "Register time",
        LastLoginTime: "Last login time",
        PageName: "Page name",
        ButtonBame: "Button name",
        RouteName: "Route name",
        Route: "Route",
        Value: "Value",
        AutoCall: "Auto Call",
        ManualCall: "Manual Call",
        CallMode: "Modo de llamada",
        RuleNumber: "Rule number",
        RuleName: "Rule name",
        RuleDetails: "Rule details"
    },
    menuLgy: {
        ResultStatistics:'Statistics report of reminder results',
        OverdueReasonStat:'Statistical report of overdue reasons',
        CallRecordData: "Call Record Data",
        CollectionPerformanceDetails: "Collection performance details",
        RememberStatistics: "Remember Statistics",
        SelectCouponTemplate: "Please select a coupon template",
        PageManagement: "Page management",
        RouteManagement: "Route management",
        MenuList: "Menu list",
        MenuDetails: "Menu details",
        CallSequenceConfiguration: "Call sequence configuration",
        EmployeeReviewDetails: "Employee review details",
        CustomerInformation: "Customer Information",
        Audit: "Audit",
        DistributionRules: "Distribution rules"
    },
    tipsLgy: {
        EnterPageName: "Please enter the page name",
        EnterRouteName: "Please enter the route name",
        ConfirmDelete: "Confirm delete",
        EnterRouteValue: "Please enter the route value",
        SelectButton: "请选择按钮",
        SelectRoute: "请选择路由",
        EnterNumber: "Please enter a number,number,number...",
        NotPTPAndNextCallTime: "Please do not fill in PTP time and Next call time simultaneously",
        NextCallTimeTips: "If already saved PTP , please do not fill this content",
        SelectPerson:"Please select the person to call",
        SelectCallTime: "Please select the call time",
        SelectWhetherConnect: "Please choose whether to connect",
    }
};
